import { render, staticRenderFns } from "./CoUserInvite.vue?vue&type=template&id=93282fe8&scoped=true&"
import script from "./CoUserInvite.vue?vue&type=script&lang=ts&"
export * from "./CoUserInvite.vue?vue&type=script&lang=ts&"
import style0 from "./CoUserInvite.vue?vue&type=style&index=0&id=93282fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93282fe8",
  null
  
)

export default component.exports